import { render, staticRenderFns } from "./PrinterLocationCategories.vue?vue&type=template&id=61867486&"
import script from "./PrinterLocationCategories.vue?vue&type=script&lang=js&"
export * from "./PrinterLocationCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports